import { Button, Checkbox, Icon, Input, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';

import {
  filterOptions,
  useFilterProductsManagement,
} from '../../hooks/useFilterProductsManagement';

interface FilterDesktopProps {
  isLoading: boolean;
}
export const FilterDesktop = ({ isLoading }: FilterDesktopProps) => {
  const {
    productBlockFilter,
    filterForm,
    handleInputBlur,
    handleClearSearchTerm,
    setSearchTerm,
    handleBlockTypeFilter,
  } = useFilterProductsManagement();

  return (
    <Box flexDirection={{ base: 'column', md: 'row' }} justifyContent="space-between" width="full">
      <HStack width="30%" space={Spacing['inline.xxxs']}>
        <Input
          placeholder="Pesquise por Nome, CNPJ, Gestor ou Emissor"
          noValidate={true}
          name="searchTerm"
          onSubmitEditing={filterForm.handleSubmit(setSearchTerm)}
          control={filterForm.control}
          onBlur={handleInputBlur}
          isDisabled={isLoading}
          error={filterForm.formState.errors.searchTerm}
          autoComplete="off"
          variant="rounded"
          inputRightElement={
            <Pressable
              onPress={() => {
                filterForm.formState.isValid ? handleClearSearchTerm() : null;
              }}
              pr={filterForm.formState.isValid ? 3 : 4}
              isDisabled={isLoading}>
              <Icon name={filterForm.formState.isValid ? 'Close' : 'Search'} size="xxxs" />
            </Pressable>
          }
        />
        <Button
          variant="primary"
          onPress={() => {
            filterForm.handleSubmit(setSearchTerm)();
          }}
          isDisabled={!filterForm.formState.isValid || isLoading}>
          Buscar
        </Button>
      </HStack>
      <HStack
        justifyContent={{ base: 'flex-start', md: 'flex-end' }}
        alignItems="center"
        py={{ base: Spacing['stack.xxs'], md: Spacing['stack.quarck'] }}
        space={Spacing['inline.xxxs']}>
        <Text fontSize={Typography['fontsize.md']} color="neutral.medium" variant="regular">
          Filtre por produto:
        </Text>
        <Checkbox
          testId="asset-product-checkbox"
          aria-label="asset-product-checkbox"
          columns={1}
          options={filterOptions}
          optionPadding={{ right: Spacing['stack.nano'] }}
          onChange={handleBlockTypeFilter}
          selectedValues={[productBlockFilter]}
          showAsRadio
          customProps={{ isDisabled: isLoading }}
        />
      </HStack>
    </Box>
  );
};
